import React from "react";
import {createBrowserRouter, createRoutesFromElements, Route} from "react-router-dom";

// Páginas principais
import Home from "../pages/backoffice/home";
import Login from "pages/auth/login";
import MasterContainer from "../shared/components/container";
import PoliticaDePrivacidade from "../pages/auth/politica-de-privacidade";

// Usuários
import BackofficeUsersList from "../pages/backoffice/users";
import CreateBackofficeUserPage from "../pages/backoffice/users/create";
import EditBackofficeUserPage, {editUserLoader} from "../pages/backoffice/users/edit";

// Motoristas
import TruckDriversList from "../pages/backoffice/motoristas";
import CreateMotoristaPage from "../pages/backoffice/motoristas/create";
import EditMotoristaPage, {editMotoristaLoader} from "../pages/backoffice/motoristas/edit";

// Clientes
import ClientsListPage from "../pages/backoffice/clients";
import CreateClientPage from "../pages/backoffice/clients/create";
import EditClientPage, {editClientLoader} from "../pages/backoffice/clients/edit";
import ClientDriversList from "../pages/backoffice/clients/drivers";

// Gerentes
import ManagersListPage from "../pages/backoffice/managers";
import CreateManagerPage from "../pages/backoffice/managers/create";
import EditManagerPage, {editManagerLoader} from "../pages/backoffice/managers/edit";

// Unidades de negócio
import BusinessUnitListPage from "../pages/backoffice/bussiness-units";
import CreateBusinessUnitPage from "../pages/backoffice/bussiness-units/create";
import EditBusinessUnitPage, {editBusinessUnitLoader} from "../pages/backoffice/bussiness-units/edit";

// Frotas e operações
import FleetList from "../pages/backoffice/fleets";
import CreateFleetPage from "../pages/backoffice/fleets/create";
import EditFleetPage, {editFleetLoader} from "../pages/backoffice/fleets/edit";
import FleetDriversList from "../pages/backoffice/fleets/drivers";

// Configurações de bonificações
import BonusConfigsList from "../pages/backoffice/fleets/bonus-configs";
import EditBonusConfigPage, {editBonusConfigLoader} from "../pages/backoffice/fleets/bonus-configs/edit";
import CreateEngineLoadBonusConfigPage from "../pages/backoffice/fleets/bonus-configs/engine-load/create";
import CreateEngineLoadExceptionConfigPage from "../pages/backoffice/fleets/bonus-configs/engine-load-exception/create";
import CreateInertiaBonusConfigPage from "../pages/backoffice/fleets/bonus-configs/inertia/create";

// Outros backoffice
import AppMessagesList from "../pages/backoffice/app-messages";
import CreateAppMessagePage from "../pages/backoffice/app-messages/create";
import ClientDashboardPage from "../pages/backoffice/dashboard";
import VehiclePlatesPage from "../pages/backoffice/vehicle-plates";
import CreateVehiclePlate from "pages/backoffice/vehicle-plates/create";
import EditVehiclePlatePage, {editVehiclePlateLoader} from "../pages/backoffice/vehicle-plates/edit";
import RelatorioPremiacaoGeralPage from "../pages/backoffice/relatorios/geral";
import TrackerLogsListPage from "../pages/backoffice/rastreamento-logs/list";

// Torre
import FleetTypePage from "../pages/torre/fleet-type";
import OperationTypePage from "../pages/torre/operation-type";
import ReferenceGroupPage from "../pages/torre/reference-group";
import VehicleTypePage from "../pages/torre/vehicle-type";
import ReferencePage from "../pages/torre/reference";
import ProductPage from "../pages/torre/product";
import JustificationPage from "../pages/torre/justification";
import RoutePage from "../pages/torre/route";

// Programação
import ProgrammingListPage from "../pages/backoffice/programming";
import CreateProgrammingPage from "../pages/backoffice/programming/create";
import EditProgrammingPage from "../pages/backoffice/programming/edit";
import TorrePage from "../pages/torre";

export const adminRoutes = (profile: string, isLogged: boolean, username: string) => createBrowserRouter(createRoutesFromElements(<>

    <Route path="backoffice/relatorios/geral"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><RelatorioPremiacaoGeralPage/></MasterContainer>}/>

    <Route path="backoffice/users"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><BackofficeUsersList/></MasterContainer>}/>
    <Route
        path="backoffice/users/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditBackofficeUserPage/></MasterContainer>}
        loader={editUserLoader}
    />
    <Route path="backoffice/users/create" element={<MasterContainer profile={profile} username={username}
                                                                    isLogged={isLogged}><CreateBackofficeUserPage/></MasterContainer>}/>

    <Route path="login" element={<Login/>}/>
    <Route path="home" element={<MasterContainer profile={profile} username={username}
                                                 isLogged={isLogged}><Home/></MasterContainer>}/>
    <Route path="/" element={<MasterContainer profile={profile} username={username}
                                              isLogged={isLogged}><Home/></MasterContainer>}/>
    <Route path="*" element={<MasterContainer profile={profile} username={username}
                                              isLogged={isLogged}><Home/></MasterContainer>}/>

    <Route path="backoffice/motoristas"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><TruckDriversList/></MasterContainer>}/>

    <Route path="backoffice/motoristas/create" element={<MasterContainer profile={profile} username={username}
                                                                         isLogged={isLogged}><CreateMotoristaPage/></MasterContainer>}/>

    <Route
        path="backoffice/motoristas/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditMotoristaPage/></MasterContainer>}
        loader={editMotoristaLoader}/>

    <Route path="backoffice/clients"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ClientsListPage/></MasterContainer>}/>

    <Route path="backoffice/clients/create" element={<MasterContainer profile={profile} username={username}
                                                                      isLogged={isLogged}><CreateClientPage/></MasterContainer>}/>

    <Route
        path="backoffice/clients/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditClientPage/></MasterContainer>}
        loader={editClientLoader}/>

    <Route path="backoffice/managers"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ManagersListPage/></MasterContainer>}/>

    <Route path="backoffice/managers/create" element={<MasterContainer profile={profile} username={username}
                                                                       isLogged={isLogged}><CreateManagerPage/></MasterContainer>}/>

    <Route
        path="backoffice/managers/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditManagerPage/></MasterContainer>}
        loader={editManagerLoader}/>

    <Route path="backoffice/business-units"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><BusinessUnitListPage/></MasterContainer>}/>

    <Route path="backoffice/business-units/create" element={<MasterContainer profile={profile} username={username}
                                                                             isLogged={isLogged}><CreateBusinessUnitPage/></MasterContainer>}/>

    <Route
        path="backoffice/business-units/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditBusinessUnitPage/></MasterContainer>}
        loader={editBusinessUnitLoader}/>

    <Route path="backoffice/fleets"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><FleetList/></MasterContainer>}/>

    <Route path="backoffice/fleets/create" element={<MasterContainer profile={profile} username={username}
                                                                     isLogged={isLogged}><CreateFleetPage/></MasterContainer>}/>

    <Route
        path="backoffice/fleets/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditFleetPage/></MasterContainer>}
        loader={editFleetLoader}/>

    <Route path="backoffice/fleets/bonus-configs"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><BonusConfigsList/></MasterContainer>}/>

    <Route
        path="backoffice/fleets/bonus-configs/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditBonusConfigPage/></MasterContainer>}
        loader={editBonusConfigLoader}/>

    <Route path="backoffice/fleets/bonus-configs/engine-load/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateEngineLoadBonusConfigPage/></MasterContainer>}/>

    <Route path="backoffice/fleets/bonus-configs/engine-load-exception/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateEngineLoadExceptionConfigPage/></MasterContainer>}/>


    <Route path="backoffice/fleets/bonus-configs/inertia/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateInertiaBonusConfigPage/></MasterContainer>}/>


    <Route path="backoffice/clients/drivers/"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ClientDriversList/></MasterContainer>}/>


    <Route path="backoffice/fleets/:id/drivers/"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><FleetDriversList/></MasterContainer>}/>

    <Route path="backoffice/app-messages"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><AppMessagesList/></MasterContainer>}/>

    <Route path="backoffice/app-messages/create" element={<MasterContainer profile={profile} username={username}
                                                                           isLogged={isLogged}><CreateAppMessagePage/></MasterContainer>}/>

    <Route path="backoffice/dashboard"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ClientDashboardPage/></MasterContainer>}/>

    {/*#region vehicle-plates*/}
    <Route path="backoffice/vehicle-plates"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><VehiclePlatesPage/></MasterContainer>}/>

    <Route path="backoffice/vehicle-plates/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateVehiclePlate/></MasterContainer>}/>

    <Route path="backoffice/vehicle-plates/edit/:id"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><EditVehiclePlatePage/></MasterContainer>}
           loader={editVehiclePlateLoader}
    />

    <Route path="torre/vehicle-types"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><VehicleTypePage/></MasterContainer>}/>

    <Route path="torre/fleet-types"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><FleetTypePage/></MasterContainer>}/>

    <Route path="torre/operation-types"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><OperationTypePage/></MasterContainer>}/>

    <Route path="torre/reference-groups"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ReferenceGroupPage/></MasterContainer>}/>


    <Route path="torre/references"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ReferencePage/></MasterContainer>}/>

    <Route path="torre/products"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ProductPage/></MasterContainer>}/>

    <Route path="torre/justifications"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><JustificationPage/></MasterContainer>}/>

    <Route path="torre/routes"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><RoutePage/></MasterContainer>}/>

    <Route path="torre/index.tsx"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><TorrePage/></MasterContainer>}/>


    {/*#endregion*/}


    <Route
        path="politica-de-privacidade"
        element={<PoliticaDePrivacidade/>}/>

    <Route path="backoffice/rastreamento-logs/list"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><TrackerLogsListPage/></MasterContainer>}/>

    <Route path="backoffice/programming"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ProgrammingListPage/></MasterContainer>}/>

    <Route path="backoffice/programming/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateProgrammingPage/></MasterContainer>}/>

    <Route path="backoffice/programming/edit/:id"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><EditProgrammingPage/></MasterContainer>}/>
</>));
